import { useMemo, useRef, useState } from 'react';
import { useData } from 'src/contexts/data';
import { ModelOfContractBiddingItem } from 'src/database';
import api from 'src/services/api';
import { useAuth } from 'src/contexts/auth';

export const useListContractItemsController = () => {
	const { selectedContractBidding } = useData();
	const { userAgencyId } = useAuth();

	const [loading, setLoading] = useState(false);
	const [contractItemsData, setContractItemsData] = useState<ModelOfContractBiddingItem[]>([]);
	const [removableBiddingContractItem, setRemovableBiddingContractItem] = useState<ModelOfContractBiddingItem | null>(
		null
	);
	const [biddingContractItemRemoveDialog, setBiddingContractItemRemoveDialog] = useState(false);

	const toast: any = useRef();

	const getContractBiddingItems = () => {
		setLoading(true);
		api.get(`bidding-contract-items/${selectedContractBidding?.ID}`)
			.then((response) => {
				setContractItemsData(
					response.data.filter((item: any) => {
						return item.ORGAO === userAgencyId;
					})
				);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const openBiddingContractItemRemoveDialog = (biddingContractItem: ModelOfContractBiddingItem) => {
		setRemovableBiddingContractItem(biddingContractItem);
		setBiddingContractItemRemoveDialog(true);
	};

	const closeBiddingContractItemRemoveDialog = () => {
		setBiddingContractItemRemoveDialog(false);
	};

	const removeContractItem = (item: ModelOfContractBiddingItem) => {
		setLoading(true);

		api.delete(`bidding-contract-items/${item.ID}`)
			.then(() => {
				getContractBiddingItems();
				setBiddingContractItemRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Item removido',
					detail: 'O item foi removido com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				console.log(err);
				setBiddingContractItemRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Item não removido',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useMemo(() => {
		getContractBiddingItems();
	}, [selectedContractBidding?.ID]);

	return {
		getListContratcItems: {
			loading,
			contractItemsData,
			toast,
			removableBiddingContractItem,
			biddingContractItemRemoveDialog,
		},
		handleListContractItems: {
			removeContractItem,
			openBiddingContractItemRemoveDialog,
			closeBiddingContractItemRemoveDialog,
		},
	};
};
